// extracted by mini-css-extract-plugin
export var avatar = "_md-3";
export var avatarContainer = "_md-2";
export var avatarSpacer = "_md-5";
export var avatarSpacerContainer = "_md-4";
export var avatarStackContainer = "_md-1";
export var bubble = "_md-0";
export var remainderBubble = "_md-6";